import React, { useState } from 'react';
import { Box, Text, Button, Group, Card, Divider } from '@mantine/core';
// import { QueryBuilderMantine } from '@react-querybuilder/mantine';
import { QueryBuilder } from 'react-querybuilder';
import type { Field, RuleGroupType } from 'react-querybuilder';
import { CustomQueryBuilder } from './CustomQueryBuilder';
import 'react-querybuilder/dist/query-builder.css';
import { IconCheck, IconDisc } from '@tabler/icons';

interface RecordFieldFilterProps {
  id: string;
  label: string;
  description?: string;
  fieldPath: string;
  required: boolean;
  value: RuleGroupType;
  onChange: (value: RuleGroupType) => void;
}

// Define the available fields for filtering
const fields: Field[] = [
  {
    name: 'status',
    label: 'Status',
    valueEditorType: 'select',
    values: [
      { name: 'open', label: 'Open' },
      { name: 'pending', label: 'Pending' },
      { name: 'closed', label: 'Closed' },
    ],
  },
  {
    name: 'priority',
    label: 'Priority',
    type: 'number',
    operators: [
      { name: 'greaterThan', label: '>' },
      { name: 'lessThan', label: '<' },
      { name: 'equals', label: '=' },
    ],
  },
  {
    name: 'tags',
    label: 'Tags',
    valueEditorType: 'multiselect',
    operators: [
      { name: 'contains', label: 'Contains' },
      { name: 'containsAll', label: 'Contains All' },
      { name: 'containsAny', label: 'Contains Any' },
    ],
    values: [
      { name: 'urgent', label: 'Urgent' },
      { name: 'bug', label: 'Bug' },
      { name: 'feature', label: 'Feature' },
    ],
  },
  {
    name: 'created_at',
    label: 'Created At',
    valueEditorType:'text',
    operators: [
      { name: 'greaterThan', label: 'After' },
      { name: 'lessThan', label: 'Before' },
      { name: 'between', label: 'Between' },
    ],
  },
];

const defaultQuery: RuleGroupType = {
  combinator: 'and',
  rules: [],
};

export const RecordFieldFilter: React.FC<RecordFieldFilterProps> = ({
  id,
  label,
  description,
  value,
  onChange,
}) => {
  const [localValue, setLocalValue] = useState<RuleGroupType>(value || defaultQuery);
  const [hasChanges, setHasChanges] = useState(false);
  console.log("RecordFieldFilter", value);

  const handleLocalChange = (newValue: RuleGroupType) => {
    setLocalValue(newValue);
    setHasChanges(true);
  };

  const handleSave = () => {
    onChange(localValue);
    setHasChanges(false);
  };

  return (
    <Box>
      <Text weight={500} size="sm" >{label}</Text>
      {description && (
        <Text size="xs" color="dimmed" mb="xs">{description}</Text>
      )}
      <Box p={0} sx={{border: '0.0625rem solid #ced4da', borderRadius: '0.25rem'}}>
        <Box p="xs" py={0} mb="xs">
          <CustomQueryBuilder
            fields={fields}
            query={localValue}
            onQueryChange={handleLocalChange}
            addRuleToNewGroups={false}
            autoSelectField={true}
            autoSelectOperator={true}
            showCombinatorsBetweenRules={false}
            showNotToggle={false}
            showCloneButtons={false}
            resetOnFieldChange={true}
            resetOnOperatorChange={false}
          />
        </Box>
        <Divider />
        <Group position="right" p="xs">
          <Button 
            // variant='light'
            onClick={handleSave}
            disabled={!hasChanges}
            leftIcon={<IconCheck size={16} />}
            color='indigo'
            size='xs'
          >
          Save Changes
          </Button>
        </Group>
      </Box>
    </Box>
  );
}; 